
import videojs from "video.js";

$ = jQuery;

$(document).ready(function() {
   const videos = document.querySelectorAll('.video-js');

   videos.forEach(el => {
      const video = videojs(el);
      const playIcon = $('input[name="video_play_icon"]').attr('data-play-icon');

      $('.vjs-fullscreen-control .vjs-icon-placeholder').addClass('icon icon-full-screen');
      $('.vjs-mute-control .vjs-icon-placeholder').addClass('icon icon-sound');
      $('.vjs-big-play-button').css('background-image', `url("${playIcon}")`);

      video.on('play', () => {
         $('.vjs-play-control .vjs-icon-placeholder').addClass('icon icon-pause');
      });

      video.on('pause', () => {
         $('.vjs-play-control .vjs-icon-placeholder').removeClass('icon icon-pause');
      })
   })
});